import { render, staticRenderFns } from "./login.vue?vue&type=template&id=2608a3d0"
var script = {}
import style0 from "./login.vue?vue&type=style&index=0&id=2608a3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports